import { jsx, jsxs } from 'react/jsx-runtime';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { NavBar } from './NavBar/index.js';
import { TopBar } from './TopBar/index.js';
import '../../tslib.es6-17e0406b.js';
import 'react-router';
import 'react-router-dom';
import 'react-perfect-scrollbar';
import '@mui/material';
import 'moment';
import '../../utils/direitos.js';
import '../../utils/getItemLocalStorage.js';
import '@mui/icons-material/Close';
import '../../components/CodeReader/BarcodeScanner.js';
import 'quagga';
import '../../components/Loading.js';
import '../../components/CodeReader/QRCodeScanner.js';
import 'react-qr-reader';
import 'date-fns/locale/pt-BR';
import '@mui/x-date-pickers/AdapterDateFns';
import '@mui/x-date-pickers/LocalizationProvider';
import '@mui/x-date-pickers/DatePicker';
import '@mui/x-date-pickers/TimePicker';
import '../../components/QuantityInput.js';
import 'react-number-format';
import '../../components/AvatarSwitch.js';
import '../../utils/getInitials.js';
import '@mui/icons-material/ArrowDropDown';
import '../../components/DateRange.js';
import '../../components/DatePicker.js';
import '@mui/x-date-pickers/DateTimePicker';
import '../../components/FilterDate.js';
import 'react-feather';
import '../../components/FullScreenBackdrop.js';
import '../../components/Label.js';
import 'clsx';
import '../../components/LoadingScreen.js';
import 'nprogress';
import '../../components/Logo.js';
import '../../components/OnlineIndicator.js';
import '../../components/Page.js';
import 'react-helmet';
import '../../utils/analytics.js';
import '../../components/QuestionDialog.js';
import '@mui/icons-material/MoreVert';
import '@mui/icons-material/Edit';
import '@mui/icons-material/Delete';
import '../../components/SplashScreen.js';
import '../../components/StackAvatars.js';
import '../../components/TitleBack.js';
import '@mui/icons-material/ArrowBack';
import './NavBar/NavItem.js';
import '@mui/icons-material/ExpandMore';
import '@mui/icons-material/ExpandLess';
import '../../global/constants/index.js';
import './TopBar/Account.js';
import './TopBar/Debugger/index.js';
import '../../utils/msToTime.js';
import './TopBar/Debugger/DebugFile.js';
import '../../utils/clipboardCopy.js';
import './TopBar/Settings.js';
import 'change-case';
import '../../hooks/useSettings.js';
import '../../contexts/SettingsContext.js';

const PREFIX = 'DashboardLayout';
const classes = {
    root: `${PREFIX}-root`,
    wrapper: `${PREFIX}-wrapper`,
    contentContainer: `${PREFIX}-contentContainer`,
    content: `${PREFIX}-content`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        // @ts-ignore
        backgroundColor: theme.palette.background.dark,
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
    },
    [`& .${classes.wrapper}`]: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingTop: 'var(--top)',
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 'var(--left)',
        },
    },
    [`& .${classes.contentContainer}`]: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
    },
    [`& .${classes.content}`]: {
        flex: '1 1 auto',
        height: '100%',
        overflow: 'auto',
    },
}));
const DashboardLayout = ({ children, user, themes, navConfig, logService, logAxios, logMonitorUrl, logout, }) => {
    const [isMobileNavOpen, setMobileNavOpen] = useState(false);
    return (jsx(SnackbarProvider, Object.assign({ maxSnack: 10, autoHideDuration: 3000 }, { children: jsxs(Root, Object.assign({ className: classes.root }, { children: [jsx(TopBar, { onMobileNavOpen: () => setMobileNavOpen(true), themes: themes, user: user, logService: logService, logAxios: logAxios, logMonitorUrl: logMonitorUrl, logout: logout }), jsx(NavBar, { onMobileClose: () => setMobileNavOpen(false), openMobile: isMobileNavOpen, navConfig: navConfig }), jsx("div", Object.assign({ className: classes.wrapper }, { children: jsx("div", Object.assign({ className: classes.contentContainer }, { children: jsx("div", Object.assign({ className: classes.content }, { children: children })) })) }))] })) })));
};

export { DashboardLayout as default };
